import Tags from "../components/Tags/Tags";
import {
  BsFillTagsFill,
  BsSearch,
  BsCheckLg,
  BsInfoCircleFill,
} from "react-icons/bs";
import { GrFormClose } from "react-icons/gr";
import UIConfig from "../constants/UIConfig";

export function checkCondition(condition, input, label, props) {
  const action = condition;
  switch (action) {
    case "inline":
      return (
        <div className="row my-2">
          <div className="col-3">{label}</div>
          <div className="col-9">{input}</div>
        </div>
      );
    case "radio-inline":
      return (
        <>
          <div className="col-1">{label}</div>
          <div className="col-1">{input}</div>
        </>
      );
    case "flex":
      return (
        <div className="row my-2">
          <div className="col-12">{label}</div>
          <div className="col-12">{input}</div>
        </div>
      );
    case "flex-no-label":
      return (
        <>
          <div className="row my-2">
            <div className="col-12">{input}</div>
          </div>
        </>
      );
    case "flex-tags":
      return (
        <>
          <div className="row my-2">
            <div className="col-12">{label}</div>
            <div className="col-12">
              <div className=" d-flex form-control p-0 m-0">
                <div className="col-1 p-1">
                  <BsFillTagsFill color="rgb(227, 120, 47)" />
                </div>
                {props.tagsArray.length !== 0 && props.addTag && (
                  <div
                    className="col-11 create-tag-Container"
                    onClick={() => {
                      props.clickHandler();
                    }}
                  >
                    <Tags
                      data={props.tagsArray}
                      className=" row"
                      condition="close-tag"
                      closeHandler={props.closeHandler}
                      typeOf={props.typeOf}
                    />
                  </div>
                )}
                {(!props.addTag || props.tagsArray.length === 0) && (
                  <div className="col-11 p-0">{input}</div>
                )}
              </div>
            </div>
          </div>
        </>
      );
    case "flex-search":
      return (
        <>
          <div className="row my-2">
            <div className="col-12">
              <div className=" d-flex form-control p-0 m-0">
                <div className="col-1 p-1">
                  <BsSearch color="rgba(138, 138, 138, 1)" />
                </div>
                <div className="col-11 p-0">{input}</div>
              </div>
            </div>
          </div>
        </>
      );
    case "flex-search-tag":
      return (
        <>
          <div className="row my-2">
            <div className="col-12">
              <div className=" d-flex form-control p-0 m-0">
                {props.tagsArray.length !== 0 && props.addTag && (
                  <>
                    <div
                      className="col-11 create-tag-Container"
                      onClick={() => {
                        props.clickHandler();
                      }}
                    >
                      <Tags
                        data={props.tagsArray}
                        className="row tag-display"
                        condition="info-close-tag"
                        closeHandler={props.closeHandler}
                        checkClickHandler={props.checkClickHandler}
                        infoHandler={props.infoHandler}
                        typeOf={props.typeOf}
                      />
                    </div>
                    <div className="col-1 p-1">
                      <BsSearch color="rgba(138, 138, 138, 1)" />
                    </div>
                  </>
                )}

                {(!props.addTag || props.tagsArray.length === 0) && (
                  <>
                    <div className="col-1 p-1">
                      <BsSearch color="rgba(138, 138, 138, 1)" />
                    </div>
                    <div className="col-11 p-0">{input}</div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      );
    default:
      break;
  }
}

export const detectBrowser = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (userAgent.indexOf("SamsungBrowser") > -1) {
    return "Samsung Internet";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    return "Opera";
  } else if (userAgent.indexOf("Trident") > -1) {
    return "Internet Explorer";
  } else if (userAgent.indexOf("Edge") > -1) {
    return "Edge";
  } else if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } else {
    return "Unknown";
  }
};

export function checkTagCondition(
  condition,
  e,
  closeHandler,
  checkClickHandler,
  infoHandler,
  typeOf,
  clickInfo,
) {
  const action = condition;
  switch (action) {
    case "regular":
      return <>{e}</>;
    case "regular-click-info":
      return <div onClick={() => clickInfo(e)}>{e}</div>;
    case "close-tag":
      return (
        <>
          <div className="col-11">{e}</div>
          <div className="col-1">
            <div className="close-tag" onClick={() => closeHandler(e, typeOf)}>
              <GrFormClose />
            </div>
          </div>
        </>
      );
    case "info-close-tag":
      return (
        <>
          <div className="col-1 p-0 m-0">
            <div
              className="check-click"
              onClick={() => checkClickHandler(e, typeOf)}
            >
              <BsCheckLg />
            </div>
          </div>
          <div className="col-9 p-0 m-0">{e}</div>
          <div className="col-1 p-0 m-0">
            <div className="info-tag" onClick={() => infoHandler(e, typeOf)}>
              <BsInfoCircleFill />
            </div>
          </div>
          <div className="col-1 p-0 m-0">
            <div className="closeTag" onClick={() => closeHandler(e, typeOf)}>
              <GrFormClose />
            </div>
          </div>
        </>
      );

    default:
      break;
  }
}

export const formatCamelCaseWords = (text) => {
  if (!text || typeof text !== "string") return text;

  return text
    .split(" ")
    .map((word) => {
      if (
        word.includes("http") ||
        word.includes("@") ||
        word.includes(".") ||
        /\d/.test(word)
      ) {
        return word;
      }

      const camelCasePattern = /^[A-Z]?[a-z]+(?:[A-Z][a-z]+)+$/;

      if (camelCasePattern.test(word)) {
        return word.replace(/([a-z])([A-Z])/g, "$1 $2");
      }

      return word;
    })
    .join(" ");
};

const ACRONYMS = ["ED", "LOC", "NPS", "OCD", "QA", "PTSD", "PHI", "MN"];

export const formatAcronyms = (text) => {
  if (!text || typeof text !== "string") return text;

  return text.replace(/\b[a-zA-Z]+\b/g, (word) => {
    const upperWord = word.toUpperCase();

    if (ACRONYMS.some((a) => a.toUpperCase() === upperWord)) {
      return upperWord;
    }

    return word;
  });
};

export function checkIconCondition(
  selected,
  name,
  iconClass,
  onClick,
  onDragStart,
  bgColor,
  boxImage,
  iconCondition,
  selectedClass,
  link,
  rightLink,
  closeHandler,
) {
  const action = selected;
  switch (action) {
    case false:
      return (
        <div className="row justify-content-center">
          <div className="col-2">
            <div
              key={name}
              className={`draggable-container-unselected ${selectedClass}`}
            >
              <div
                className={`draggable ${iconClass}`}
                onClick={onClick}
                draggable
                onDragStart={onDragStart}
                style={{ backgroundColor: bgColor }}
              >
                <div className="icon-Image">{boxImage}</div>
              </div>
              <div className="icon-text">{name}</div>
            </div>
          </div>
        </div>
      );
    case true:
      return (
        <div className="row justify-content-center">
          <div className="col-2">
            {iconCondition && (
              <div
                key={name}
                className={`draggable-container ${selectedClass}`}
              >
                <div
                  className="closeTab-home-icon"
                  onClick={closeHandler}
                ></div>
                {link}
                {rightLink}
                <div
                  className={`draggable ${iconClass}`}
                  onClick={onClick}
                  draggable
                  onDragStart={onDragStart}
                  style={{ backgroundColor: bgColor }}
                >
                  <div className="icon-Image">{boxImage}</div>
                </div>
                {/* <div className='icon-text'>{name}</div> */}
              </div>
            )}
          </div>

          <div className="col-2">
            {!iconCondition && (
              <div
                key={name}
                className={`draggable-container ${selectedClass}`}
              >
                <div
                  className="closeTab-home-icon"
                  onClick={closeHandler}
                ></div>
                {link}
                {rightLink}
                <div
                  className={`draggable ${iconClass}`}
                  onClick={onClick}
                  draggable
                  onDragStart={onDragStart}
                  style={{ backgroundColor: bgColor }}
                >
                  <div className="icon-Image">{boxImage}</div>
                </div>
                {/* <div className='icon-text'>{name}</div> */}
              </div>
            )}
          </div>
        </div>
      );
    default:
      break;
  }
}

export const formatDateTimeEST = (isoDateString) => {
  if (!isoDateString) return "-----";

  const date = new Date(isoDateString);
  if (isNaN(date)) return isoDateString;

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: UIConfig.branding.timeZone || "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZoneName: "short", // 👈 KEY
  });

  return formatter.format(date);
};

export const formatDateEST = (isoDateString) => {
  if (!isoDateString) return "-----";

  const date = new Date(isoDateString);
  if (isNaN(date)) return isoDateString;

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: UIConfig.branding.timeZone || "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return formatter.format(date);
};

// ✅ Date formatting helper (preserved from old code)
export const formatDate = (isoDateString) => {
  if (!isoDateString) return "-----";
  const [datePart] = isoDateString.split("T");
  return `${datePart.split("-").reverse().join("-")}`;
};

export const formatDateTime = (isoDateString) => {
  if (!isoDateString) return "-----";
  const match = isoDateString.match(
    /(\d{4})[-/](\d{2})[-/](\d{2})[T\s](\d{2}):(\d{2}):(\d{2})/,
  );
  if (!match) {
    return isoDateString;
  }
  const [, year, month, day, hourStr, minute, second] = match;
  let hour = parseInt(hourStr, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  const pad = (n) => n.toString().padStart(2, "0");
  return `${month}/${day}/${year} ${pad(hour)}:${minute}:${second} ${ampm}`;
};